'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const SalesAreaChart = dynamic(() => import('./SalesAreaChart'), { ssr: false });
const TeamVolumeBarChart = dynamic(() => import('./TeamVolumeBarChart'), { ssr: false });

export default function DashboardCharts() {
  return (
    <div className="grid lg:grid-cols-3 gap-6">
      <div className="lg:col-span-2">
        <SalesAreaChart />
      </div>
      <div>
        <TeamVolumeBarChart />
      </div>
    </div>
  );
}